export enum SocialType {
  Google,
  Apple,
  LinkedIn,
  Facebook,
}
